import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';
import { PaymentDetailsQueryResponseWrapper, PaymentDetailsSubmitRequest, PaymentDetailsSubmitResponse } from '@app/_models/home/paymentdetails';

const baseUrl = `${environment.apiUrl}/signup`;

@Injectable({providedIn: 'root'})
export class HomeService {

  constructor(private httpClient: HttpClient) { }

  getPaymentDetails(id: string): Observable<PaymentDetailsQueryResponseWrapper> {
    return this.httpClient.get<PaymentDetailsQueryResponseWrapper>(`${baseUrl}/payment-details?id=${id}`);
  }

  postPaymentDetails(req: PaymentDetailsSubmitRequest): Observable<PaymentDetailsSubmitResponse> {
    return this.httpClient.post<PaymentDetailsSubmitResponse>(`${baseUrl}/payment-details`, req);
  }

}
